import alertify from 'alertifyjs';
import axios from 'axios';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import DataTable from 'react-data-table-component';
import { apiRoutes } from '../../AppSettings';
import { AuthContext } from '../../contexts/AuthContext';
import Util from '../../Util';
import Breadcrumb from '../shared/Breadcrumb';
import SideNav from './shared/SideNav';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';

const SET_SPECIALITY = "SET_SPECIALITY"
const SET_POPUPTiTLE = "SET_POPUPTiTLE";

const customStyles = {
    title: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    rows: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    headCells: {
      style: {
        paddingLeft: '15px', // override the cell padding for head cells
        paddingRight: '15px',
        fontWeight: 'bold',
        fontSize: '15px'
      },
    },
    cells: {
      style: {
        paddingLeft: '15px', // override the cell padding for data cells
        paddingRight: '15px',
        paddingTop: '10px', // override the cell padding for data cells
        paddingBottom: '8px',
        fontSize: '15px',
      },
    },
  };

const initialValue = {
    title: 'Add',
    speciality: {
        specialityId: 0,
        specialityNumber: "",
        specialityName: "",
        specialityImage: "",
        isActive: true
    }
}

const reducer = (state, action) => {
    switch(action.type)
    {
        case SET_SPECIALITY:
            return {...state, speciality: action.speciality}
        case SET_POPUPTiTLE:
            return {...state, title: action.title}
    }
} 

const Specialities = (props) => {
    const [data, setData] = useState([]);
    const { userState } = useContext(AuthContext);
    const [modalShow, setModalShow] = useState(false);
 
    const [state, dispature] = useReducer(reducer, initialValue);

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };

    useEffect(() => {
        loadGrid();
    }, []);

    const getFiles = (e) => {
        var reader = new FileReader();
        reader.onload = function(upload) {
            dispature({type: SET_SPECIALITY, speciality: {...state.speciality, specialityImage:  upload.target.result}})
        };
	    reader.readAsDataURL(e.target.files[0]);
    }

    const loadGrid = () => {
        axios.get(apiRoutes.GetAllSpeciality, options)
        .then((response) => {
            if (response.status === 200) {
                const data = response.data;
                setData(data);
            }
        }, (error) => {
            console.log(error);
        });
    }
    
    const handleSubmit = () => {
        axios.post(apiRoutes.UpsertSpeciality, JSON.stringify(state.speciality), options)
        .then((response) => {
            if(response.status === 200)
            {
                setModalShow(false)
                alertify.success("Speciality added/updated successfully");
                
                loadGrid();
            }
        }, (error) => {
            console.log(error);
        });
    }

    const handleDelete = (id) => {
        console.log(id);

        alertify.confirm("Warning!", "Are you sure want to delete?",
        function(){
            axios.post(apiRoutes.DeleteSpeciality, JSON.stringify({id: id}), options)
            .then((response) => {
                alertify.success("Speciality deleted successfully");
                loadGrid();
            }, (error) => {
                console.log(error.response);
            });
        },
        function(){
          
        });
    }

    const OpenModel = (id) => {
        var selectedSpeciality = {};
        if(id == 0)
        {
            selectedSpeciality = {
                specialityId: 0,
                specialityNumber: "",
                specialityName: "",
                specialityImage: "",
                isActive: true
            }
            dispature({type: SET_POPUPTiTLE, title: "Add Speciality"})
    
        }
        else
        {
            selectedSpeciality = data.filter((item) => {
                return item.specialityId == id
            })[0]

            dispature({type: SET_POPUPTiTLE, title: "Update Speciality"})
     
        }
        console.log(selectedSpeciality);
        dispature({type: SET_SPECIALITY, speciality: selectedSpeciality})
        setModalShow(true);
    }

    const columns = [
        {
            name: '#Speciality',
            selector: 'specialityNumber',
            sortable: true
        },
        {
            name: 'Specialities',
            selector: 'specialitiyName',
            sortable: true,
            cell: row => <h6 className="table-avatar">
                            <a href="#" className="avatar avatar-sm mr-2">
                                <img className="avatar-img" src={Util.loadImage(row.specialityImage)}  alt="Speciality" />
                            </a>
                            <a href="#">{row.specialityName}</a>
                        </h6>
        },
        {
            name: 'Actions',
            sortable: true,
            cell: row => <div className="actions">
                            <a className="btn btn-sm bg-success-light" data-toggle="modal" onClick={() => OpenModel(row.specialityId)} >
                                <i className="fe fe-pencil"></i> Edit
                            </a>
                            <a data-toggle="modal" href="#delete_modal" className="btn btn-sm bg-danger-light" onClick={e => handleDelete(row.specialityId)}>
                                <i className="fe fe-trash"></i> Delete
                            </a>
                        </div>
        }
    ];

    return (  
        <div>
            <Breadcrumb title="Specialities"></Breadcrumb>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='specialities' />
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <div className="row">
                                <div className="col-sm-12 col">
                                    
                                </div>
                                <div className="col-md-12">
                                    <div className="card">
                                        <div style={{paddingRight: "8px"}}>
                                            <a href="" data-toggle="modal" class="btn btn-primary float-right mt-2" onClick={() => OpenModel(0)}>Add</a>
                                        </div>
                                        <div className="card-body">
                                            <DataTable
                                                title="Specialities" 
                                                columns={columns}
                                                data={data}
                                                customStyles={customStyles}
                                                pagination
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={modalShow}  onHide={() => setModalShow(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {state.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-body">
                        <form onSubmit={e => {e.preventDefault(); handleSubmit();}} >
                            <div className="row form-row">
                                <div className="col-12 col-sm-6">
                                    <div className="form-group">
                                        <label>Specialities</label>
                                        <input type="text" required className="form-control" value={state.speciality.specialityName} onChange={e => dispature({type: SET_SPECIALITY, speciality: {...state.speciality, specialityName:  e.target.value}})} />
								     </div>
                                </div>
                                <div className="col-12 col-sm-6">
                                    <div className="form-group">
                                        <label>Image</label>
                                        <input type="file" className="form-control" 
                                                                onChange={e => getFiles(e)}
                                                                required
                                                                accept="image/*" /> 
                                    </div>
                                </div>
                                
                            </div>
                            <button type="submit" className="btn btn-primary btn-block">Save Changes</button>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}
 
export default Specialities;